/**
 * Timeline Controls Constants
 *
 * Shared constants for timeline control components
 */

// Popper offset configuration
export const POPPER_OFFSET_MODIFIER = {
  name: 'offset',
  options: {
    offset: [0, 4], // 0.25rem vertical offset
  },
}

export const TOGGLE_TIMEOUT_DELAY = 150

// the point at which to switch to/from individual/combined toggle button ui
export const CONTROLS_BREAKPOINT = 'lg'
